import { CustomersTable } from "@src/components/tables";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Button, Modal } from "@src/components/atoms";
import { useAdminContext } from "@src/context/adminContext";
import { CustomerForm } from "@src/components/forms/admin/CustomerForm";
import { useNavigate } from "react-router-dom";

const CustomersPage = () => {
  const admin = useAdminContext();
  const { customers, selectedCustomer, setSelectedCustomer } = admin;
  const [showCreateModal, setShowCreateModal] = useState(false);
  const navigate = useNavigate();

  const handleCreate = () => {
    setShowCreateModal(true);
  };
  const closeEditing = () => {
    setShowCreateModal(false);
  };

  const onCustomerClick = (customerId) => {
    console.log("customer id", customerId);
  };

  return (
    <div>
      <h2 className="text-center p-2">Customers page</h2>
      {showCreateModal && (
        <div className="p-4">
          <CustomerForm
            data={null}
            onSubmit={() => {
              setShowCreateModal(false);
              navigate(0);
            }}
            isNew={true}
          />
        </div>
      )}
      {!showCreateModal && (
        <div className="text-sm relative p-4">
          <div className="w-1/3">
            <Button icon="plus" onClick={handleCreate}>
              Create New Customer
            </Button>
          </div>
          {!!customers && (
            <CustomersTable
              events={customers}
              onCustomerClick={onCustomerClick}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default CustomersPage;
